import React, { useState, useEffect } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { useHistory } from "react-router-dom";
import { Spin } from 'antd'

const styles = {
    load: () => ({
        display: 'flex',
        justifyContent: 'center',
        alignItems: "center",
        height: '100vh',
        backgroundColor: '#F4F3EF'
    })
}

const HomePage = () => {
    const { user, isAuthenticated, isLoading } = useAuth0();
    const history = useHistory();

    useEffect(() => {
        setTimeout(() => {
            history.push('/dashboard')
        }, 1000);

    }, [])
    return (
        <div style={styles.load()}>
            <Spin
                tip="Please wait while we load your data"
                size='large'
                spinning={true}
            >
            </Spin>
        </div>
    )
}

export default HomePage